import type { GetApiCoursesType } from './getApiCoursesType';
import type { GetApiCoursesStatus } from './getApiCoursesStatus';

export type GetApiCoursesParams = {
/**
 * 조회할 강의의 타입
 */
type: GetApiCoursesType;
/**
 * 사용자 ID (type이 ENROLLED일 때 필수)
 */
userId?: string;
/**
 * 수강 상태 (type이 ENROLLED일 때 사용)
 */
status?: GetApiCoursesStatus;
/**
 * 페이지 번호 (0부터 시작)
 */
page?: number;
/**
 * 페이지 크기
 */
size?: number;
};
